import { useEffect, useState } from 'react';
import { InputAdornment, TextField } from '@mui/material';
import { formatearMonto, parsearMontoDesdeTexto } from '../utils/formatoMonto';

/**
 * Igual que InputMonto (separador de miles en vivo), pero como TextField de Material UI para los
 * formularios que usan ese kit en vez de Bootstrap. El valor que sube por `onChange` es siempre el
 * número (o '' si está vacío), nunca el texto formateado.
 */
export default function InputMontoMui({ value, onChange, ...props }) {
    const [texto, setTexto] = useState(formatearMonto(value));

    useEffect(() => {
        setTexto(formatearMonto(value));
    }, [value]);

    const handleChange = (e) => {
        const numero = parsearMontoDesdeTexto(e.target.value);
        setTexto(formatearMonto(numero));
        onChange(numero);
    };

    return (
        <TextField
            type="text"
            inputMode="numeric"
            value={texto}
            onChange={handleChange}
            InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
            {...props}
        />
    );
}
